import { Route, Routes } from 'react-router-dom';
import Messages from '../pages/admin-view/Messages';
import AdminUsers from '../pages/admin-view/AdminUsers';
import Projects from '../pages/admin-view/Projects';
import Services from '../pages/admin-view/Services';
import Blogs from '../pages/admin-view/Blogs';
import Jobs from '../pages/admin-view/AddJob';
import JobManagement from '../pages/admin-view/JobManagement';
import AuthLayout from '../components/auth/layout';
import AuthLogin from '../pages/auth/login';
import AuthRegister from '../pages/auth/register';
import PageNotFound from '../pages/not-found/layout';
import MainLayout from '../components/layout/MainLayout';
import ProtectedRoute from '../utils/auth/ProtectedRoute';
import AuthRoute from '../utils/auth/AuthRoute'; 
const RootRouting = () => {
  return (
    <Routes>
    <Route element={<AuthRoute />}>
    <Route path="/auth" element={<AuthLayout />}>
  <Route index element={<AuthLogin />} />
  <Route path="login" element={<AuthLogin />} />
  <Route path="register" element={<AuthRegister />} />
</Route>
    </Route>

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
        <Route path="/" element={<AdminUsers />} />
          <Route path="/users" element={<Messages />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/services" element={<Services />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/job-management" element={<JobManagement />} />
        </Route>
      </Route>

      {/* 404 page */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default RootRouting;